<template>
  <div class="mt-4">
    <DataTable
      :value="datos"
      :loading="cargando"
      :dataKey="dataKey"
      :paginator="paginacion"
      :rows="filasPorPagina"
      :filters="filtrosInternos"
      class="p-datatable-sm"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50]"
      :currentPageReportTemplate="`Mostrando {first} a {last} de {totalRecords} ${nombreEntidad}`"
      responsiveLayout="scroll"
      showGridlines
      selectionMode="single"
      @row-dblclick="$emit('doble-click', $event.data)"
      v-model:expandedRows="expandedRowsInterno"
    >
      <!-- Cabecera de búsqueda (se puede ocultar con la prop 'mostrarBusqueda') -->
      <template #header v-if="mostrarBusqueda">
        <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
          <span class="block mt-2 md:mt-0 p-input-icon-left">            
            <InputText
              v-model="filtrosInternos['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>
      <!-- Mensajes por defecto -->
      <template #loading>
        Buscando {{ nombreEntidad }}, por favor espere...
      </template>
      <template #empty>
        No existen registros de {{ nombreEntidad }}.
      </template>

      <!-- Expander Column -->
      <Column expander v-if="permitirExpansion" style="width: 5rem" />

      <!-- Renderizado Dinámico de Columnas -->
      <Column
        v-for="col in columnas"
        :key="col.field"
        :field="col.field"
        :header="col.header"
        :sortable="col.sortable"
      >
        <template #body="{ data }">
          <!-- Si usamos un slot (ej. para fechas, badges), lo exponemos dinámicamente -->
          <slot v-if="$slots[col.field]" :name="col.field" :data="data"></slot>
          
          <!-- Si no hay slot específico, imprimimos el valor directo -->
          <span v-else>{{ data[col.field] }}</span>
        </template>
      </Column>
      <!-- Columna de Acciones Comunes (editar, eliminar, etc) -->
      <Column style="width: 10rem;" header="ACCIONES" v-if="mostrarAcciones">
        <template #body="slotProps">
          <slot name="acciones" :data="slotProps.data"></slot>
        </template>
      </Column>

      <!-- Row Expansion -->
      <template #expansion="slotProps" v-if="permitirExpansion">
        <slot name="expansion" :data="slotProps.data"></slot>
      </template>
    </DataTable>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
export default {
  name: "TablaBase",
  props: {
    datos: { type: Array, required: true },
    columnas: { type: Array, required: true }, // Array de objetos {field: 'nombre', header: 'NOMBRE', sortable: true}
    cargando: { type: Boolean, default: false },
    dataKey: { type: String, default: "id" },
    paginacion: { type: Boolean, default: true },
    filasPorPagina: { type: Number, default: 10 },
    nombreEntidad: { type: String, default: "Registros" },
    mostrarBusqueda: { type: Boolean, default: true },
    mostrarAcciones: { type: Boolean, default: true },
    permitirExpansion: { type: Boolean, default: false },
    expandedRows: { type: [Array, Object], default: () => [] }
  },
  computed: {
    expandedRowsInterno: {
      get() { return this.expandedRows; },
      set(val) { this.$emit('update:expandedRows', val); }
    }
  },
  data() {
    return {
      filtrosInternos: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
};
</script>